import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import parse from 'html-react-parser';

class ShopDetails1 extends Component {

	render() {

		let publicUrl = process.env.PUBLIC_URL + '/'

		return <div className="ltn__shop-details-area pb-10">
			<div className="container">
				<div className="row">
					<div className="col-lg-12 col-md-12">
						<div className="ltn__shop-details-inner ltn__page-details-inner mb-60">
							{/* <div className="ltn__blog-meta">
								<ul>
									<li className="ltn__blog-category">
										<Link to="#">Featured</Link>
									</li>
									<li className="ltn__blog-category">
										<Link className="bg-orange" to="#">For Rent</Link>
									</li>
									<li className="ltn__blog-date">
										<i className="far fa-calendar-alt" />May 19, 2021
									</li>
									<li>
										<Link to="#"><i className="far fa-comments" />35 Comments</Link>
									</li>
								</ul>
							</div> */}
							{/* <h4 className="title-2"></h4> */}
							<h1>Sri Hari Nagar</h1>
							<label><span className="ltn__secondary-color"><i className="flaticon-pin" /></span>Manimangalam - Kolathur,Chennai</label>
							{/* <h4 className="title-2">Description</h4> */}
							<p> Welcome to Sri Hari Nagar by Success Property Enterprises

Discover Sri Hari Nagar, an exceptional residential project located in the serene neighborhood of Manimangalam - Kolathur, Chennai. Developed by the trusted Success Property Enterprises, this thoughtfully planned community offers a blend of tranquility, accessibility, and modern living.

At Sri Hari Nagar, every detail is designed to provide you with a harmonious lifestyle. With well-laid plots, excellent connectivity to key parts of Chennai, and a commitment to quality, this project ensures a safe and promising investment for your future. Success Property Enterprises, known for their integrity and customer-centric approach, brings their expertise to create homes that exceed expectations.

Join the vibrant community at Sri Hari Nagar and experience the perfect balance of comfort and convenience. Your dream home awaits!</p>
							{/* <p>To the left is the modern kitchen with central island, leading through to the unique breakfast family room which feature glass walls and doors out onto the garden and access to the separate utility room.</p> */}
							<div className="ltn__property-details-gallery mb-30">
								<div className="row">
									<div className="col-md-6">
										<a href=""  data-rel="lightcase:myCollection">
											<img className="mb-30" src={publicUrl + "assets/img/projects/Hari Nagar/img1.jpg"} alt="Image" />
										</a>
										{/* <a href={publicUrl + "assets/img/plans/img4.jpeg"} data-rel="lightcase:myCollection">
											<img className="mb-30" src={publicUrl + "assets/img/plans/img4.jpeg"} alt="Image" />
										</a> */}
									</div>
									<div className="col-md-6">
										<a href=""  data-rel="lightcase:myCollection">
											<img className="mb-30" src={publicUrl + "assets/img/projects/Hari Nagar/img2.jpg"} alt="Image" />
										</a>
									</div>
									<div className="col-md-6 mt-4">
										<a href="" data-rel="lightcase:myCollection">
											<img className="mb-30" src={publicUrl + "assets/img/projects/Hari Nagar/img3.jpg"} alt="Image" />
										</a>
										{/* <a href={publicUrl + "assets/img/plans/img4.jpeg"} data-rel="lightcase:myCollection">
											<img className="mb-30" src={publicUrl + "assets/img/plans/img4.jpeg"} alt="Image" />
										</a> */}
									</div>
									<div className="col-md-6 mt-4">
										<a href=""  data-rel="lightcase:myCollection">
											<img className="mb-30" src={publicUrl + "assets/img/projects/Hari Nagar/img4.jpg"} alt="Image" />
										</a>
									</div>
								</div>
							</div>
							
							<h4 className="title-2">Property Details</h4>
							<div className="row">
                                <div className="col-lg-6 col-md-6 col-sm-12 section-bg-1">
                                    <div className="prop-main-cont">
                                    <div className="left-cont">
									    <p>Plot Area:</p>
                                        <p>Start Year:</p>
                                        <p>Plot Price:</p>
                                        <p>Total No of Plot:</p>
                                        <p>Status:</p>
										<p>Approval:</p>
                                    </div>
                                    <div className="right-cont">
                                         <p>600 - 2000 Sqft</p>
                                        <p>2024</p>
                                        <p className="head-mine">1600 Per Sqft</p>
                                        <p>324</p>
                                        <p>Available</p>
										<p>DTCP</p>
                                    </div>
                                    </div>
                                </div>
                                {/* <div className="col-lg-6 col-md-6 col-sm-12">
                                    <div className="search-by-place-imgs">
                                        <img src={publicUrl + "assets/img/projects/Manimozhi Nagar/img2.jpg"} alt="#" />
                                    </div>
                                </div> */}
                            </div>
							
						
							<h4 className="title-2 mb-10">Amenities</h4>
							<div className="property-details-amenities mb-60">
								<div className="row">
									<div className="col-lg-4 col-md-6">
										<div className="ltn__menu-widget">
											<ul>
												<li>
													<label className="checkbox-item">Bangalore Highway Road 4km
														<input type="checkbox" defaultChecked="checked" />
														<span className="checkmark" />
													</label>
												</li>
												<li>
													<label className="checkbox-item">15min drive from vandalur
														<input type="checkbox" defaultChecked="checked" />
														<span className="checkmark" />
													</label>
												</li>
												<li>
													<label className="checkbox-item">Site near by manfort CBSE School
														<input type="checkbox" defaultChecked="checked" />
														<span className="checkmark" />
													</label>
												</li>
												
											</ul>
										</div>
									</div>
									<div className="col-lg-4 col-md-6">
										<div className="ltn__menu-widget">
											<ul>
												
												<li>
													<label className="checkbox-item">20min Drive from Tambaram
														<input type="checkbox" defaultChecked="checked" />
														<span className="checkmark" />
													</label>
												</li>
												<li>
													<label className="checkbox-item">Palikaranai sipcot & Sriperumbathur sipcot
														<input type="checkbox" defaultChecked="checked" />
														<span className="checkmark" />
													</label>
												</li>
											</ul>
										</div>
									</div>
									
									
								</div>
							</div>
							{/* <h4 className="title-2">Property Video</h4>
							<div className="ltn__video-bg-img ltn__video-popup-height-500 bg-overlay-black-50 bg-image mb-60" data-bs-bg={publicUrl + "assets/img/others/5.jpg"}>
								<a className="ltn__video-icon-2 ltn__video-icon-2-border---" target="blank" href="https://www.youtube.com/watch?v=7alzSjnlBLU?autoplay=1&showinfo=0" data-rel="lightcase:myCollection">
									<i className="fa fa-play" />
								</a>
							</div> */}
							<h4 className="title-2">Location</h4>
							<div className="property-details-google-map mb-60">
								<iframe src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3888.5193102495364!2d79.994778!3d12.938587000000002!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMTLCsDU2JzE4LjkiTiA3OcKwNTknNDEuMiJF!5e0!3m2!1sen!2sin!4v1734603743460!5m2!1sen!2sin" width="100%" height="100%" frameBorder={0} allowFullScreen aria-hidden="false" tabIndex={0} />
                            </div>
							{/* <h4 className="title-2">Floor Plans</h4>
							
							<div className="ltn__apartments-plan-area product-details-apartments-plan mb-60">
								<div className="ltn__tab-menu ltn__tab-menu-3 ltn__tab-menu-top-right-- text-uppercase--- text-center---">
									<div className="nav">
										<a data-bs-toggle="tab" href="#liton_tab_3_1">First Floor</a>
										<a className="active show" data-bs-toggle="tab" href="#liton_tab_3_2">Second Floor</a>
										<a data-bs-toggle="tab" href="#liton_tab_3_3" >Third Floor</a>
										<a data-bs-toggle="tab" href="#liton_tab_3_4" >Top Garden</a>
									</div>
								</div>
								<div className="tab-content">
									<div className="tab-pane fade" id="liton_tab_3_1">
										<div className="ltn__apartments-tab-content-inner">
											<div className="row">
												<div className="col-lg-7">
													<div className="apartments-plan-img">
														<img src={publicUrl + "assets/img/others/10.png"} alt="#" />
													</div>
												</div>
												<div className="col-lg-5">
													<div className="apartments-plan-info ltn__secondary-bg--- text-color-white---">
														<h2>First Floor</h2>
														<p>Enimad minim veniam quis nostrud exercitation ullamco laboris.
															Lorem ipsum dolor sit amet cons aetetur adipisicing elit sedo
															eiusmod tempor.Incididunt labore et dolore magna aliqua.
															sed ayd minim veniam.</p>
													</div>
												</div>
												<div className="col-lg-12">
													<div className="product-details-apartments-info-list  section-bg-1">
														<div className="row">
															<div className="col-lg-6">
																<div className="apartments-info-list apartments-info-list-color mt-40---">
																	<ul>
																		<li><label>Total Area</label> <span>2800 Sq. Ft</span></li>
																		<li><label>Bedroom</label> <span>150 Sq. Ft</span></li>
																	</ul>
																</div>
															</div>
															<div className="col-lg-6">
																<div className="apartments-info-list apartments-info-list-color mt-40---">
																	<ul>
																		<li><label>Belcony/Pets</label> <span>Allowed</span></li>
																		<li><label>Lounge</label> <span>650 Sq. Ft</span></li>
																	</ul>
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
									<div className="tab-pane fade active show" id="liton_tab_3_2">
										<div className="ltn__product-tab-content-inner">
											<div className="row">
												<div className="col-lg-7">
													<div className="apartments-plan-img">
														<img src={publicUrl + "assets/img/others/10.png"} alt="#" />
													</div>
												</div>
												<div className="col-lg-5">
													<div className="apartments-plan-info ltn__secondary-bg--- text-color-white---">
														<h2>Second Floor</h2>
														<p>Enimad minim veniam quis nostrud exercitation ullamco laboris.
															Lorem ipsum dolor sit amet cons aetetur adipisicing elit sedo
															eiusmod tempor.Incididunt labore et dolore magna aliqua.
															sed ayd minim veniam.</p>
													</div>
												</div>
												<div className="col-lg-12">
													<div className="product-details-apartments-info-list  section-bg-1">
														<div className="row">
															<div className="col-lg-6">
																<div className="apartments-info-list apartments-info-list-color mt-40---">
																	<ul>
																		<li><label>Total Area</label> <span>2800 Sq. Ft</span></li>
																		<li><label>Bedroom</label> <span>150 Sq. Ft</span></li>
																	</ul>
																</div>
															</div>
															<div className="col-lg-6">
																<div className="apartments-info-list apartments-info-list-color mt-40---">
																	<ul>
																		<li><label>Belcony/Pets</label> <span>Allowed</span></li>
																		<li><label>Lounge</label> <span>650 Sq. Ft</span></li>
																	</ul>
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
									<div className="tab-pane fade" id="liton_tab_3_3">
										<div className="ltn__product-tab-content-inner">
											<div className="row">
												<div className="col-lg-7">
													<div className="apartments-plan-img">
														<img src={publicUrl + "assets/img/others/10.png"} alt="#" />
													</div>
												</div>
												<div className="col-lg-5">
													<div className="apartments-plan-info ltn__secondary-bg--- text-color-white---">
														<h2>Third Floor</h2>
														<p>Enimad minim veniam quis nostrud exercitation ullamco laboris.
															Lorem ipsum dolor sit amet cons aetetur adipisicing elit sedo
															eiusmod tempor.Incididunt labore et dolore magna aliqua.
															sed ayd minim veniam.</p>
													</div>
												</div>
												<div className="col-lg-12">
													<div className="product-details-apartments-info-list  section-bg-1">
														<div className="row">
															<div className="col-lg-6">
																<div className="apartments-info-list apartments-info-list-color mt-40---">
																	<ul>
																		<li><label>Total Area</label> <span>2800 Sq. Ft</span></li>
																		<li><label>Bedroom</label> <span>150 Sq. Ft</span></li>
																	</ul>
																</div>
															</div>
															<div className="col-lg-6">
																<div className="apartments-info-list apartments-info-list-color mt-40---">
																	<ul>
																		<li><label>Belcony/Pets</label> <span>Allowed</span></li>
																		<li><label>Lounge</label> <span>650 Sq. Ft</span></li>
																	</ul>
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
									<div className="tab-pane fade" id="liton_tab_3_4">
										<div className="ltn__product-tab-content-inner">
											<div className="row">
												<div className="col-lg-7">
													<div className="apartments-plan-img">
														<img src={publicUrl + "assets/img/others/10.png"} alt="#" />
													</div>
												</div>
												<div className="col-lg-5">
													<div className="apartments-plan-info ltn__secondary-bg--- text-color-white---">
														<h2>Top Garden</h2>
														<p>Enimad minim veniam quis nostrud exercitation ullamco laboris.
															Lorem ipsum dolor sit amet cons aetetur adipisicing elit sedo
															eiusmod tempor.Incididunt labore et dolore magna aliqua.
															sed ayd minim veniam.</p>
													</div>
												</div>
												<div className="col-lg-12">
													<div className="product-details-apartments-info-list  section-bg-1">
														<div className="row">
															<div className="col-lg-6">
																<div className="apartments-info-list apartments-info-list-color mt-40---">
																	<ul>
																		<li><label>Total Area</label> <span>2800 Sq. Ft</span></li>
																		<li><label>Bedroom</label> <span>150 Sq. Ft</span></li>
																	</ul>
																</div>
															</div>
															<div className="col-lg-6">
																<div className="apartments-info-list apartments-info-list-color mt-40---">
																	<ul>
																		<li><label>Belcony/Pets</label> <span>Allowed</span></li>
																		<li><label>Lounge</label> <span>650 Sq. Ft</span></li>
																	</ul>
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div> */}
							{/* APARTMENTS PLAN AREA END */}
							
						</div>
					</div>
				</div>
			</div>
		</div>
			
        }
}

export default ShopDetails1